<div class="content-mask" *ngIf="featureDisabled">
  <div class="content-mask__content">
    <p class="content-mask__text">
      This is showing sample Hotspots data. Enable Hotspots to visualize trends
      across all your errors.
    </p>
    <button
      class="btn btn--upgrade"
      (click)="openUpgradeModal($event)"
      data-feature="hotspots"
      type="button"
    >
      Enable Hotspots
    </button>
  </div>
</div>
<h1 class="dash-title">
  Hotspots
  <span class="dash-title__dropdown" ngbDropdown="ngbDropdown">
    <button
      class="btn"
      ngbDropdownToggle="ngbDropdownToggle"
      [ngbTooltip]="selectedHotspotType?.description"
      container="body"
      type="button"
    >
      {{ selectedHotspotType?.label }}
    </button>
    <ul
      class="dropdown-menu--reduced-padding"
      ngbDropdownMenu="ngbDropdownMenu"
    >
      <li *ngFor="let hotspotType of hotspotTypes; trackBy: trackByIndex">
        <a
          (click)="selectHotspotType(hotspotType)"
          ngbDropdownItem="ngbDropdownItem"
          ><i
            class="list-icon glyphicon"
            [ngClass]="{
              'glyphicon-check': hotspotType === selectedHotspotType
            }"
          ></i
          >{{ hotspotType.label }}</a
        >
      </li>
    </ul></span
  >
</h1>
<div [ngSwitch]="selectedHotspotType?.dataFormat">
  <ab-attr-hotspots
    *ngSwitchCase="'attribute'"
    [featureDisabled]="featureDisabled"
    [identifier]="selectedHotspotType.identifier"
    [project]="project"
    [dur]="dur"
    [lastN]="lastN"
  ></ab-attr-hotspots>
  <ab-diff-stat-hotspots
    *ngSwitchCase="'diffStat'"
    [featureDisabled]="featureDisabled"
    [identifier]="selectedHotspotType.identifier"
    [project]="project"
    [dur]="dur"
    [lastN]="lastN"
  ></ab-diff-stat-hotspots>
</div>
